/**
 * Labstep
 *
 * @module components/Entity/Action/Remove
 * @desc Remove action
 */

import { EntityActionToggle } from 'labstep-web/components/Entity/Action/Toggle';
import type React from 'react';
import type { EntityActionRemoveProps } from './types';

export const EntityActionRemove: React.FC<EntityActionRemoveProps> = (
  props,
) => <EntityActionToggle action="remove" {...props} />;
